import { LanguageType } from "../../types";

export default function getFontFamily(language: LanguageType): string {
  return language === "zh-HK" || language === "zh-TW"
    ? "'Noto Sans TC', sans-serif"
    : "'Noto Sans KR', sans-serif";
}
